import { useDispatch } from 'react-redux';
import { Checkbox, Form, Input, message } from 'antd';
import { useLoginMutation } from '@/services/auth-api';
import { setCredentials } from '@/stores/auth';
import LogoUrl from '@/assets/images/logo.png';
import { LockSvg, PlayCircleSvg, UserSvg } from '@/assets/icons';
import PageTitle from '@/components/page-title';
import Button from '@/components/button';
import { StyledForm, FormHeader, FormFooter } from './styles';
import { useNavigate } from 'react-router-dom';

const username = localStorage.getItem('username');
const remember = !!username;

const LoginPage = () => {
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const user = await login({ username: values.username, password: values.password }).unwrap();
      dispatch(setCredentials(user));
      if (values.remember) {
        localStorage.setItem('username', values.username);
      } else {
        localStorage.removeItem('username');
      }
      navigate('/');
    } catch (err) {
      message.error(err.data.message);
      return;
    }
  };

  return (
    <StyledForm form={form} initialValues={{ username, remember }} onFinish={onFinish}>
      <PageTitle label="Login" />
      <FormHeader>
        <img src={LogoUrl} width="166" alt="Logo" />
        <div className="app-title">Indiana Adoption Program</div>
        <div className="page-title">Login</div>
        <div className="page-description">Sign In to your account</div>
      </FormHeader>

      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: 'Please input your Username!',
          },
        ]}
      >
        <Input prefix={<UserSvg />} placeholder="Username" autoFocus={!remember} />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Please input your Password!',
          },
        ]}
      >
        <Input prefix={<LockSvg />} type="password" placeholder="Password" autoFocus={remember} />
      </Form.Item>

      <FormFooter>
        <Form.Item name="remember" valuePropName="checked" className="m-0">
          <Checkbox>Remember me</Checkbox>
        </Form.Item>
        <Button type="primary" danger htmlType="submit" icon={<PlayCircleSvg />} loading={isLoading}>
          Login
        </Button>
      </FormFooter>
    </StyledForm>
  );
};

export default LoginPage;
